var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isProcessing)?_c('div',{staticClass:"code-edit"},[_c('form-qr',{staticClass:"code-edit__form",attrs:{"collection":_vm.collection}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }